/* BIZORA COD PRO v3.4 — pestañas de contenido de la ficha. Sin dependencias. */
(function () {
  if (customElements.get('bz-pdp-tabs')) return;
  customElements.define(
    'bz-pdp-tabs',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs.forEach((t, i) => {
          t.addEventListener('click', () => this.select(i));
          t.addEventListener('keydown', (e) => {
            var n = this.tabs.length;
            var next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % n;
            else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = n - 1;
            if (next !== null) {
              e.preventDefault();
              this.select(next);
              this.tabs[next].focus();
            }
          });
        });
      }

      select(index) {
        this.tabs.forEach((t, i) => {
          var on = i === index;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !on;
        });
      }
    }
  );
})();
